// Dugout formation presets: starting scenes for a NEW drawing, keyed by
// `${formatieEigenTeam}_${formatieTegenstander}` (own team = #FFF865, opponent = #E14F4F).
// Coordinates are on the 615x615 dugout canvas; placed programmatically by utils/placeFormation.
// GENERATED from the Dugout presets by scripts/extract-formations.mjs — do not hand-edit.

export interface DugoutFormationObject {
  variation: string;
  color: string | null;
  text: string | null;
  left: number;
  top: number;
  angle?: number;
}

export interface DugoutFormationScene {
  field: string;
  voetbalvorm: string;
  pitchType: 'default' | 'futsal';
  background: string;
  iconType: string;
  objects: DugoutFormationObject[];
}

export const dugoutFormations: Record<string, DugoutFormationScene> = {
  '1112_1112': {
    field: 'field-futsal',
    voetbalvorm: '5',
    pitchType: 'futsal',
    background: '#00AADB',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 309.63,
        top: 553.67,
      },
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 303.67,
        top: 51.96,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 309.63,
        top: 532.38,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 306.22,
        top: 462.53,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '2',
        left: 307.93,
        top: 329.65,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '4',
        left: 253.41,
        top: 261.5,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '5',
        left: 362.44,
        top: 262.35,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 305.37,
        top: 73.25,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '2',
        left: 307.07,
        top: 286.2,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '5',
        left: 254.26,
        top: 352.65,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '4',
        left: 366.7,
        top: 351.79,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 307.93,
        top: 158.43,
      },
    ],
  },
  '1112_1121': {
    field: 'field-futsal',
    voetbalvorm: '5',
    pitchType: 'futsal',
    background: '#00AADB',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 309.63,
        top: 553.67,
      },
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 303.67,
        top: 51.96,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 309.63,
        top: 532.38,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 306.22,
        top: 462.53,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '2',
        left: 307.93,
        top: 329.65,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '4',
        left: 253.41,
        top: 261.5,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '5',
        left: 362.44,
        top: 262.35,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 305.06,
        top: 76,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 307.85,
        top: 158.98,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '2',
        left: 226.27,
        top: 264.97,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '4',
        left: 386.64,
        top: 265.66,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '5',
        left: 307.85,
        top: 410,
      },
    ],
  },
  '1112_113': {
    field: 'field-futsal',
    voetbalvorm: '5',
    pitchType: 'futsal',
    background: '#00AADB',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 309.63,
        top: 553.67,
      },
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 303.67,
        top: 51.96,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 309.63,
        top: 532.38,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 306.22,
        top: 462.53,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '2',
        left: 307.93,
        top: 329.65,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '4',
        left: 253.41,
        top: 261.5,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '5',
        left: 362.44,
        top: 262.35,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 309.63,
        top: 71.55,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 308.78,
        top: 154.18,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '5',
        left: 306.22,
        top: 397.79,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '2',
        left: 231.26,
        top: 343.28,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '4',
        left: 387.14,
        top: 342.42,
      },
    ],
  },
  '1112_131': {
    field: 'field-futsal',
    voetbalvorm: '5',
    pitchType: 'futsal',
    background: '#00AADB',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 309.63,
        top: 553.67,
      },
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 303.67,
        top: 51.96,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 309.63,
        top: 532.38,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 306.22,
        top: 462.53,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '2',
        left: 307.93,
        top: 329.65,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '4',
        left: 253.41,
        top: 261.5,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '5',
        left: 362.44,
        top: 262.35,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 305.37,
        top: 78.37,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 306.22,
        top: 157.58,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '2',
        left: 208.27,
        top: 201.02,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '4',
        left: 407.59,
        top: 201.88,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '5',
        left: 307.93,
        top: 388.42,
      },
    ],
  },
  '1112_140': {
    field: 'field-futsal',
    voetbalvorm: '5',
    pitchType: 'futsal',
    background: '#00AADB',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 309.63,
        top: 553.67,
      },
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 303.67,
        top: 51.96,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 309.63,
        top: 532.38,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 306.22,
        top: 462.53,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '2',
        left: 307.93,
        top: 329.65,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '4',
        left: 253.41,
        top: 261.5,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '5',
        left: 362.44,
        top: 262.35,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 306.22,
        top: 74.11,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '4',
        left: 416.1,
        top: 182.29,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '2',
        left: 206.56,
        top: 183.14,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 267.04,
        top: 134.58,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '5',
        left: 349.66,
        top: 135.44,
      },
    ],
  },
  '1121_1112': {
    field: 'field-futsal',
    voetbalvorm: '5',
    pitchType: 'futsal',
    background: '#00AADB',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 308.55,
        top: 554.34,
      },
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 302.97,
        top: 52.3,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 305.37,
        top: 73.25,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '2',
        left: 307.07,
        top: 286.2,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '5',
        left: 254.26,
        top: 352.65,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '4',
        left: 366.7,
        top: 351.79,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 307.93,
        top: 158.43,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '5',
        left: 307.15,
        top: 204.3,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '4',
        left: 224.87,
        top: 336.09,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '2',
        left: 390.13,
        top: 337.48,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 307.15,
        top: 458.81,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 307.85,
        top: 536.9,
      },
    ],
  },
  '1121_1121': {
    field: 'field-futsal',
    voetbalvorm: '5',
    pitchType: 'futsal',
    background: '#00AADB',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 308.55,
        top: 554.34,
      },
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 302.97,
        top: 52.3,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 305.06,
        top: 76,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 307.85,
        top: 158.98,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '2',
        left: 226.27,
        top: 264.97,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '4',
        left: 386.64,
        top: 265.66,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '5',
        left: 307.85,
        top: 410,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '5',
        left: 307.15,
        top: 204.3,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '4',
        left: 224.87,
        top: 336.09,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '2',
        left: 390.13,
        top: 337.48,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 307.15,
        top: 458.81,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 307.85,
        top: 536.9,
      },
    ],
  },
  '1121_113': {
    field: 'field-futsal',
    voetbalvorm: '5',
    pitchType: 'futsal',
    background: '#00AADB',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 308.55,
        top: 554.34,
      },
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 302.97,
        top: 52.3,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 309.63,
        top: 71.55,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 308.78,
        top: 154.18,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '5',
        left: 306.22,
        top: 397.79,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '2',
        left: 231.26,
        top: 343.28,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '4',
        left: 387.14,
        top: 342.42,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '5',
        left: 307.15,
        top: 204.3,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '4',
        left: 224.87,
        top: 336.09,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '2',
        left: 390.13,
        top: 337.48,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 307.15,
        top: 458.81,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 307.85,
        top: 536.9,
      },
    ],
  },
  '1121_131': {
    field: 'field-futsal',
    voetbalvorm: '5',
    pitchType: 'futsal',
    background: '#00AADB',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 308.55,
        top: 554.34,
      },
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 302.97,
        top: 52.3,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 305.37,
        top: 78.37,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 306.22,
        top: 157.58,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '2',
        left: 208.27,
        top: 201.02,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '4',
        left: 407.59,
        top: 201.88,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '5',
        left: 307.93,
        top: 388.42,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '5',
        left: 307.15,
        top: 204.3,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '4',
        left: 224.87,
        top: 336.09,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '2',
        left: 390.13,
        top: 337.48,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 307.15,
        top: 458.81,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 307.85,
        top: 536.9,
      },
    ],
  },
  '1121_140': {
    field: 'field-futsal',
    voetbalvorm: '5',
    pitchType: 'futsal',
    background: '#00AADB',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 308.55,
        top: 554.34,
      },
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 302.97,
        top: 52.3,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 306.22,
        top: 74.11,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '4',
        left: 416.1,
        top: 182.29,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '2',
        left: 206.56,
        top: 183.14,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 267.04,
        top: 134.58,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '5',
        left: 349.66,
        top: 135.44,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '5',
        left: 307.15,
        top: 204.3,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '4',
        left: 224.87,
        top: 336.09,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '2',
        left: 390.13,
        top: 337.48,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 307.15,
        top: 458.81,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 307.85,
        top: 536.9,
      },
    ],
  },
  '1131_1131': {
    field: 'field-03',
    voetbalvorm: '6',
    pitchType: 'default',
    background: '#69C292',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-01',
        color: null,
        text: null,
        left: 311,
        top: 406,
      },
      {
        variation: 'goal-01',
        color: null,
        text: null,
        left: 306,
        top: 197,
      },
      {
        variation: 'field-text',
        color: null,
        text: '',
        left: 595,
        top: 307.5,
        angle: 90,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '6',
        left: 268,
        top: 299,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 307,
        top: 203,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '4',
        left: 309,
        top: 240,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '9',
        left: 311,
        top: 348,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '8',
        left: 349,
        top: 300,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '6',
        left: 348,
        top: 323,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 310,
        top: 398,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '9',
        left: 309,
        top: 263,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '4',
        left: 310,
        top: 371,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '8',
        left: 270,
        top: 323,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '10',
        left: 308.4,
        top: 299.2,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '10',
        left: 310.4,
        top: 322.2,
      },
      {
        variation: 'shirt-trainer',
        color: '#333333',
        text: 'T',
        left: 212.5,
        top: 311,
      },
    ],
  },
  '1131_1212': {
    field: 'field-03',
    voetbalvorm: '6',
    pitchType: 'default',
    background: '#69C292',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-01',
        color: null,
        text: null,
        left: 311,
        top: 406,
      },
      {
        variation: 'goal-01',
        color: null,
        text: null,
        left: 306,
        top: 197,
      },
      {
        variation: 'field-text',
        color: null,
        text: '',
        left: 595,
        top: 307.5,
        angle: 90,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 271,
        top: 246,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 307,
        top: 203,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '4',
        left: 351,
        top: 245,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '7',
        left: 272,
        top: 350,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '11',
        left: 349,
        top: 352,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '6',
        left: 348,
        top: 323,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 310,
        top: 398,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '9',
        left: 309,
        top: 263,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '4',
        left: 310,
        top: 371,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '8',
        left: 270,
        top: 323,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '10',
        left: 308.4,
        top: 299.2,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '10',
        left: 310.4,
        top: 322.2,
      },
      {
        variation: 'shirt-trainer',
        color: '#333333',
        text: 'T',
        left: 213.5,
        top: 309,
      },
    ],
  },
  '113_1112': {
    field: 'field-futsal',
    voetbalvorm: '5',
    pitchType: 'futsal',
    background: '#00AADB',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 306.22,
        top: 552.82,
      },
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 307.93,
        top: 53.66,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 305.37,
        top: 73.25,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '2',
        left: 307.07,
        top: 286.2,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '5',
        left: 254.26,
        top: 352.65,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '4',
        left: 366.7,
        top: 351.79,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 307.93,
        top: 158.43,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 305.37,
        top: 531.52,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 307.07,
        top: 464.23,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '4',
        left: 229.56,
        top: 280.24,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '2',
        left: 386.29,
        top: 281.09,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '5',
        left: 308.78,
        top: 232.54,
      },
    ],
  },
  '113_1121': {
    field: 'field-futsal',
    voetbalvorm: '5',
    pitchType: 'futsal',
    background: '#00AADB',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 306.22,
        top: 552.82,
      },
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 307.93,
        top: 53.66,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 305.06,
        top: 76,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 307.85,
        top: 158.98,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '2',
        left: 226.27,
        top: 264.97,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '4',
        left: 386.64,
        top: 265.66,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '5',
        left: 307.85,
        top: 410,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 305.37,
        top: 531.52,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 307.07,
        top: 464.23,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '4',
        left: 229.56,
        top: 280.24,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '2',
        left: 386.29,
        top: 281.09,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '5',
        left: 308.78,
        top: 232.54,
      },
    ],
  },
  '113_113': {
    field: 'field-futsal',
    voetbalvorm: '5',
    pitchType: 'futsal',
    background: '#00AADB',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 306.22,
        top: 552.82,
      },
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 307.93,
        top: 53.66,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 309.63,
        top: 71.55,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 308.78,
        top: 154.18,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '5',
        left: 306.22,
        top: 397.79,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '2',
        left: 231.26,
        top: 343.28,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '4',
        left: 387.14,
        top: 342.42,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 305.37,
        top: 531.52,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 307.07,
        top: 464.23,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '4',
        left: 229.56,
        top: 280.24,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '2',
        left: 386.29,
        top: 281.09,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '5',
        left: 308.78,
        top: 232.54,
      },
    ],
  },
  '113_131': {
    field: 'field-futsal',
    voetbalvorm: '5',
    pitchType: 'futsal',
    background: '#00AADB',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 306.22,
        top: 552.82,
      },
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 307.93,
        top: 53.66,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 305.37,
        top: 78.37,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 306.22,
        top: 157.58,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '2',
        left: 208.27,
        top: 201.02,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '4',
        left: 407.59,
        top: 201.88,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '5',
        left: 307.93,
        top: 388.42,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 305.37,
        top: 531.52,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 307.07,
        top: 464.23,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '4',
        left: 229.56,
        top: 280.24,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '2',
        left: 386.29,
        top: 281.09,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '5',
        left: 308.78,
        top: 232.54,
      },
    ],
  },
  '113_140': {
    field: 'field-futsal',
    voetbalvorm: '5',
    pitchType: 'futsal',
    background: '#00AADB',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 306.22,
        top: 552.82,
      },
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 307.93,
        top: 53.66,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 306.22,
        top: 74.11,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '4',
        left: 416.1,
        top: 182.29,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '2',
        left: 206.56,
        top: 183.14,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 267.04,
        top: 134.58,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '5',
        left: 349.66,
        top: 135.44,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 305.37,
        top: 531.52,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 307.07,
        top: 464.23,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '4',
        left: 229.56,
        top: 280.24,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '2',
        left: 386.29,
        top: 281.09,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '5',
        left: 308.78,
        top: 232.54,
      },
    ],
  },
  '1212_1131': {
    field: 'field-03',
    voetbalvorm: '6',
    pitchType: 'default',
    background: '#69C292',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-01',
        color: null,
        text: null,
        left: 305,
        top: 197,
      },
      {
        variation: 'goal-01',
        color: null,
        text: null,
        left: 309,
        top: 406,
      },
      {
        variation: 'field-text',
        color: null,
        text: '',
        left: 595,
        top: 307.5,
        angle: 90,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 308,
        top: 251,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 306,
        top: 204,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '9',
        left: 309,
        top: 354,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '6',
        left: 268,
        top: 300,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '8',
        left: 347,
        top: 302,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '7',
        left: 341,
        top: 273,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 308,
        top: 398,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 345,
        top: 368,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '4',
        left: 276,
        top: 367,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '11',
        left: 273,
        top: 271,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '10',
        left: 309.4,
        top: 302.2,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '10',
        left: 314.4,
        top: 322.2,
      },
      {
        variation: 'shirt-trainer',
        color: '#333333',
        text: 'T',
        left: 212.5,
        top: 310,
      },
    ],
  },
  '1212_1212': {
    field: 'field-03',
    voetbalvorm: '6',
    pitchType: 'default',
    background: '#69C292',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-01',
        color: null,
        text: null,
        left: 309,
        top: 406,
      },
      {
        variation: 'goal-01',
        color: null,
        text: null,
        left: 305,
        top: 197,
      },
      {
        variation: 'field-text',
        color: null,
        text: '',
        left: 595,
        top: 307.5,
        angle: 90,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 273,
        top: 247,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 306,
        top: 204,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '4',
        left: 341,
        top: 248,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '7',
        left: 275,
        top: 343,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '11',
        left: 343,
        top: 344,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '7',
        left: 341,
        top: 273,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 308,
        top: 398,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 345,
        top: 368,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '4',
        left: 276,
        top: 367,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '11',
        left: 273,
        top: 271,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '10',
        left: 312.4,
        top: 299.2,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '10',
        left: 314.4,
        top: 322.2,
      },
      {
        variation: 'shirt-trainer',
        color: '#333333',
        text: 'T',
        left: 213.5,
        top: 309,
      },
    ],
  },
  '1313_1313': {
    field: 'field-02',
    voetbalvorm: '8',
    pitchType: 'default',
    background: '#69C292',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-01',
        color: null,
        text: null,
        left: 304,
        top: 140,
      },
      {
        variation: 'goal-01',
        color: null,
        text: null,
        left: 304,
        top: 460,
      },
      {
        variation: 'field-text',
        color: null,
        text: '',
        left: 595,
        top: 307.5,
        angle: 90,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '5',
        left: 382,
        top: 223,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 305,
        top: 159,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '2',
        left: 226,
        top: 225,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '10',
        left: 304,
        top: 287,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 302,
        top: 224,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 305,
        top: 376,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 304,
        top: 440,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '2',
        left: 382,
        top: 375,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '10',
        left: 304,
        top: 316,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '9',
        left: 303,
        top: 251,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '5',
        left: 229.4,
        top: 375.2,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '11',
        left: 228.4,
        top: 252.2,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '7',
        left: 381.4,
        top: 252.2,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '7',
        left: 229.4,
        top: 349.2,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '11',
        left: 382.4,
        top: 350.2,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '9',
        left: 304.4,
        top: 347.2,
      },
      {
        variation: 'shirt-trainer',
        color: '#333333',
        text: 'T',
        left: 178.5,
        top: 308,
      },
    ],
  },
  '1313_1331': {
    field: 'field-02',
    voetbalvorm: '8',
    pitchType: 'default',
    background: '#69C292',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-01',
        color: null,
        text: null,
        left: 304,
        top: 460,
      },
      {
        variation: 'goal-01',
        color: null,
        text: null,
        left: 304,
        top: 140,
      },
      {
        variation: 'field-text',
        color: null,
        text: '',
        left: 595,
        top: 307.5,
        angle: 90,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '5',
        left: 382,
        top: 223,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 305,
        top: 159,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '2',
        left: 228,
        top: 225,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '10',
        left: 304,
        top: 287,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 302,
        top: 224,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 305,
        top: 376,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 304,
        top: 440,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '2',
        left: 382,
        top: 375,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '10',
        left: 304,
        top: 316,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '9',
        left: 303,
        top: 251,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '5',
        left: 229.4,
        top: 375.2,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '11',
        left: 228.4,
        top: 252.2,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '7',
        left: 381.4,
        top: 252.2,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '6',
        left: 229.4,
        top: 284.2,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '8',
        left: 382.4,
        top: 286.2,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '9',
        left: 304.4,
        top: 347.2,
      },
      {
        variation: 'shirt-trainer',
        color: '#333333',
        text: 'T',
        left: 179.5,
        top: 308,
      },
    ],
  },
  '131_1112': {
    field: 'field-futsal',
    voetbalvorm: '5',
    pitchType: 'futsal',
    background: '#00AADB',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 305.37,
        top: 51.96,
      },
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 306.22,
        top: 552.82,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 305.37,
        top: 530.67,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '4',
        left: 213.38,
        top: 419.09,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 307.07,
        top: 455.71,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '2',
        left: 408.44,
        top: 417.38,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '5',
        left: 307.07,
        top: 213.8,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 305.37,
        top: 73.25,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '2',
        left: 307.07,
        top: 286.2,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '5',
        left: 254.26,
        top: 352.65,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '4',
        left: 366.7,
        top: 351.79,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 307.93,
        top: 158.43,
      },
    ],
  },
  '131_1121': {
    field: 'field-futsal',
    voetbalvorm: '5',
    pitchType: 'futsal',
    background: '#00AADB',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 305.37,
        top: 51.96,
      },
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 306.22,
        top: 552.82,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 305.37,
        top: 530.67,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '4',
        left: 213.38,
        top: 419.09,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 307.07,
        top: 455.71,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '2',
        left: 408.44,
        top: 417.38,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '5',
        left: 307.07,
        top: 213.8,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 305.06,
        top: 76,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 307.85,
        top: 158.98,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '2',
        left: 226.27,
        top: 264.97,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '4',
        left: 386.64,
        top: 265.66,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '5',
        left: 307.85,
        top: 410,
      },
    ],
  },
  '131_113': {
    field: 'field-futsal',
    voetbalvorm: '5',
    pitchType: 'futsal',
    background: '#00AADB',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 305.37,
        top: 51.96,
      },
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 306.22,
        top: 552.82,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 305.37,
        top: 530.67,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '4',
        left: 213.38,
        top: 419.09,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 307.07,
        top: 455.71,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '2',
        left: 408.44,
        top: 417.38,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '5',
        left: 307.07,
        top: 213.8,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 309.63,
        top: 71.55,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 308.78,
        top: 154.18,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '5',
        left: 306.22,
        top: 397.79,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '2',
        left: 231.26,
        top: 343.28,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '4',
        left: 387.14,
        top: 342.42,
      },
    ],
  },
  '131_131': {
    field: 'field-futsal',
    voetbalvorm: '5',
    pitchType: 'futsal',
    background: '#00AADB',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 305.37,
        top: 51.96,
      },
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 306.22,
        top: 552.82,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 305.37,
        top: 530.67,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '4',
        left: 213.38,
        top: 419.09,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 307.07,
        top: 455.71,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '2',
        left: 408.44,
        top: 417.38,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '5',
        left: 307.07,
        top: 213.8,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 305.37,
        top: 78.37,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 306.22,
        top: 157.58,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '2',
        left: 208.27,
        top: 201.02,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '4',
        left: 407.59,
        top: 201.88,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '5',
        left: 307.93,
        top: 388.42,
      },
    ],
  },
  '131_140': {
    field: 'field-futsal',
    voetbalvorm: '5',
    pitchType: 'futsal',
    background: '#00AADB',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 305.37,
        top: 51.96,
      },
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 306.22,
        top: 552.82,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 305.37,
        top: 530.67,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '4',
        left: 213.38,
        top: 419.09,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 307.07,
        top: 455.71,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '2',
        left: 408.44,
        top: 417.38,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '5',
        left: 307.07,
        top: 213.8,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 306.22,
        top: 74.11,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '4',
        left: 416.1,
        top: 182.29,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '2',
        left: 206.56,
        top: 183.14,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 267.04,
        top: 134.58,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '5',
        left: 349.66,
        top: 135.44,
      },
    ],
  },
  '1331_1313': {
    field: 'field-02',
    voetbalvorm: '8',
    pitchType: 'default',
    background: '#69C292',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-01',
        color: null,
        text: null,
        left: 304,
        top: 140,
      },
      {
        variation: 'goal-01',
        color: null,
        text: null,
        left: 304,
        top: 460,
      },
      {
        variation: 'field-text',
        color: null,
        text: '',
        left: 595,
        top: 307.5,
        angle: 90,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '5',
        left: 382,
        top: 223,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 305,
        top: 159,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '2',
        left: 226,
        top: 225,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '10',
        left: 304,
        top: 292,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 302,
        top: 224,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 305,
        top: 376,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 304,
        top: 440,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '2',
        left: 382,
        top: 375,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '10',
        left: 304,
        top: 316,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '9',
        left: 303,
        top: 251,
      },
      {
        variation: 'shirt-trainer',
        color: '#333333',
        text: 'T',
        left: 178.5,
        top: 308,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '5',
        left: 229.4,
        top: 375.2,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '8',
        left: 229.4,
        top: 317.2,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '6',
        left: 381.4,
        top: 318.2,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '11',
        left: 229.4,
        top: 350.2,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '7',
        left: 382.4,
        top: 350.2,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '9',
        left: 305.4,
        top: 350.2,
      },
      {
        variation: 'shirt-trainer',
        color: '#333333',
        text: 'T',
        left: 179.5,
        top: 311,
      },
    ],
  },
  '1331_1331': {
    field: 'field-02',
    voetbalvorm: '8',
    pitchType: 'default',
    background: '#69C292',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-01',
        color: null,
        text: null,
        left: 304,
        top: 460,
      },
      {
        variation: 'goal-01',
        color: null,
        text: null,
        left: 304,
        top: 140,
      },
      {
        variation: 'field-text',
        color: null,
        text: '',
        left: 595,
        top: 307.5,
        angle: 90,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '5',
        left: 382,
        top: 223,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 305,
        top: 159,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '2',
        left: 226,
        top: 225,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '8',
        left: 229,
        top: 288,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 306,
        top: 224,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 305,
        top: 376,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 304,
        top: 440,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '2',
        left: 382,
        top: 375,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '10',
        left: 307,
        top: 319,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '9',
        left: 306,
        top: 254,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '5',
        left: 229.4,
        top: 375.2,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '8',
        left: 229.4,
        top: 320.2,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '6',
        left: 382.4,
        top: 321.2,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '8',
        left: 307.4,
        top: 287.2,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '8',
        left: 381.4,
        top: 288.2,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '9',
        left: 307.4,
        top: 349.2,
      },
      {
        variation: 'ball',
        color: null,
        text: null,
        left: 302,
        top: 420.2,
      },
    ],
  },
  '140_1112': {
    field: 'field-futsal',
    voetbalvorm: '5',
    pitchType: 'futsal',
    background: '#00AADB',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 308.78,
        top: 554.52,
      },
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 305.37,
        top: 51.96,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 307.93,
        top: 530.67,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '4',
        left: 203.15,
        top: 431.86,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '2',
        left: 409.29,
        top: 434.42,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '5',
        left: 261.08,
        top: 480.42,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 356.48,
        top: 481.27,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 305.37,
        top: 73.25,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '2',
        left: 307.07,
        top: 286.2,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '5',
        left: 254.26,
        top: 352.65,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '4',
        left: 366.7,
        top: 351.79,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 307.93,
        top: 158.43,
      },
    ],
  },
  '140_1121': {
    field: 'field-futsal',
    voetbalvorm: '5',
    pitchType: 'futsal',
    background: '#00AADB',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 308.78,
        top: 554.52,
      },
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 305.37,
        top: 51.96,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 307.93,
        top: 530.67,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '4',
        left: 203.15,
        top: 431.86,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '2',
        left: 409.29,
        top: 434.42,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '5',
        left: 261.08,
        top: 480.42,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 356.48,
        top: 481.27,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 305.06,
        top: 76,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 307.85,
        top: 158.98,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '2',
        left: 226.27,
        top: 264.97,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '4',
        left: 386.64,
        top: 265.66,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '5',
        left: 307.85,
        top: 410,
      },
    ],
  },
  '140_113': {
    field: 'field-futsal',
    voetbalvorm: '5',
    pitchType: 'futsal',
    background: '#00AADB',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 308.78,
        top: 554.52,
      },
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 305.37,
        top: 51.96,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 307.93,
        top: 530.67,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '4',
        left: 203.15,
        top: 431.86,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '2',
        left: 409.29,
        top: 434.42,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '5',
        left: 261.08,
        top: 480.42,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 356.48,
        top: 481.27,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 309.63,
        top: 71.55,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 308.78,
        top: 154.18,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '5',
        left: 306.22,
        top: 397.79,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '2',
        left: 231.26,
        top: 343.28,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '4',
        left: 387.14,
        top: 342.42,
      },
    ],
  },
  '140_131': {
    field: 'field-futsal',
    voetbalvorm: '5',
    pitchType: 'futsal',
    background: '#00AADB',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 308.78,
        top: 554.52,
      },
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 305.37,
        top: 51.96,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 307.93,
        top: 530.67,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '4',
        left: 203.15,
        top: 431.86,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '2',
        left: 409.29,
        top: 434.42,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '5',
        left: 261.08,
        top: 480.42,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 356.48,
        top: 481.27,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 305.37,
        top: 78.37,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 306.22,
        top: 157.58,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '2',
        left: 208.27,
        top: 201.02,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '4',
        left: 407.59,
        top: 201.88,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '5',
        left: 307.93,
        top: 388.42,
      },
    ],
  },
  '140_140': {
    field: 'field-futsal',
    voetbalvorm: '5',
    pitchType: 'futsal',
    background: '#00AADB',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 308.78,
        top: 554.52,
      },
      {
        variation: 'goal-futsal',
        color: null,
        text: null,
        left: 305.37,
        top: 51.96,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 307.93,
        top: 530.67,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '4',
        left: 203.15,
        top: 431.86,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '2',
        left: 409.29,
        top: 434.42,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '5',
        left: 261.08,
        top: 480.42,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 356.48,
        top: 481.27,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 306.22,
        top: 74.11,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '4',
        left: 416.1,
        top: 182.29,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '2',
        left: 206.56,
        top: 183.14,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 267.04,
        top: 134.58,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '5',
        left: 349.66,
        top: 135.44,
      },
    ],
  },
  '1433_1433': {
    field: 'field-01',
    voetbalvorm: '11',
    pitchType: 'default',
    background: '#69C292',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-01',
        color: null,
        text: null,
        left: 310,
        top: 551,
      },
      {
        variation: 'goal-01',
        color: null,
        text: null,
        left: 311,
        top: 52,
      },
      {
        variation: 'field-text',
        color: null,
        text: '',
        left: 595,
        top: 307.5,
        angle: 90,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '5',
        left: 437,
        top: 199,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 310,
        top: 111,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '2',
        left: 178,
        top: 200,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '4',
        left: 265,
        top: 201,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 353,
        top: 200,
      },
      {
        variation: 'shirt-trainer',
        color: '#333333',
        text: 'T',
        left: 123,
        top: 312,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 351,
        top: 406,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 309,
        top: 500,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '2',
        left: 437,
        top: 406,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '4',
        left: 265,
        top: 405,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '10',
        left: 308,
        top: 326,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '5',
        left: 177.4,
        top: 405.8,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '8',
        left: 230.4,
        top: 326.8,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '6',
        left: 390.4,
        top: 327.8,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '9',
        left: 308.4,
        top: 257.8,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '11',
        left: 231.4,
        top: 257.8,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '7',
        left: 392.4,
        top: 260.8,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '9',
        left: 308.4,
        top: 355.8,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '10',
        left: 309.4,
        top: 288.8,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '7',
        left: 232.4,
        top: 354.8,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '11',
        left: 391.4,
        top: 355.8,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '6',
        left: 231.4,
        top: 287.8,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '8',
        left: 392.4,
        top: 290.8,
      },
      {
        variation: 'ball',
        color: null,
        text: null,
        left: 307.4,
        top: 480.8,
      },
    ],
  },
  '1433_1442': {
    field: 'field-01',
    voetbalvorm: '11',
    pitchType: 'default',
    background: '#69C292',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-01',
        color: null,
        text: null,
        left: 310,
        top: 551,
      },
      {
        variation: 'goal-01',
        color: null,
        text: null,
        left: 311,
        top: 52,
      },
      {
        variation: 'field-text',
        color: null,
        text: '',
        left: 595,
        top: 307.5,
        angle: 90,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '5',
        left: 437,
        top: 199,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 310,
        top: 111,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '2',
        left: 178,
        top: 200,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '4',
        left: 265,
        top: 201,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 353,
        top: 200,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 351,
        top: 406,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 309,
        top: 500,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '2',
        left: 437,
        top: 406,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '4',
        left: 265,
        top: 405,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '10',
        left: 308,
        top: 326,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '5',
        left: 177.4,
        top: 405.8,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '8',
        left: 230.4,
        top: 326.8,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '6',
        left: 390.4,
        top: 327.8,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '9',
        left: 308.4,
        top: 257.8,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '11',
        left: 231.4,
        top: 257.8,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '7',
        left: 392.4,
        top: 260.8,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '9',
        left: 266.4,
        top: 363.8,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '10',
        left: 351.4,
        top: 366.8,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '7',
        left: 176.4,
        top: 287.8,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '11',
        left: 435.4,
        top: 290.8,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '6',
        left: 263.4,
        top: 291.8,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '8',
        left: 353.4,
        top: 291.8,
      },
      {
        variation: 'ball',
        color: null,
        text: null,
        left: 307.4,
        top: 480.8,
      },
      {
        variation: 'shirt-trainer',
        color: '#333333',
        text: 'T',
        left: 115.5,
        top: 310,
      },
    ],
  },
  '1442_1433': {
    field: 'field-01',
    voetbalvorm: '11',
    pitchType: 'default',
    background: '#69C292',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-01',
        color: null,
        text: null,
        left: 310,
        top: 551,
      },
      {
        variation: 'goal-01',
        color: null,
        text: null,
        left: 311,
        top: 52,
      },
      {
        variation: 'field-text',
        color: null,
        text: '',
        left: 595,
        top: 307.5,
        angle: 90,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '5',
        left: 437,
        top: 199,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 310,
        top: 111,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '2',
        left: 178,
        top: 200,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '4',
        left: 265,
        top: 201,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 353,
        top: 200,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 351,
        top: 406,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 309,
        top: 500,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '2',
        left: 437,
        top: 406,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '4',
        left: 265,
        top: 405,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '10',
        left: 266,
        top: 250,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '5',
        left: 177.4,
        top: 405.8,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '8',
        left: 264.4,
        top: 326.8,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '6',
        left: 353.4,
        top: 324.8,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '9',
        left: 352.4,
        top: 252.8,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '11',
        left: 177.4,
        top: 325.8,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '7',
        left: 436.4,
        top: 326.8,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '9',
        left: 313.4,
        top: 354.8,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '10',
        left: 308.4,
        top: 286.8,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '7',
        left: 229.4,
        top: 355.8,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '11',
        left: 397.4,
        top: 358.8,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '6',
        left: 224.4,
        top: 286.8,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '8',
        left: 399.4,
        top: 283.8,
      },
      {
        variation: 'ball',
        color: null,
        text: null,
        left: 307.4,
        top: 480.8,
      },
      {
        variation: 'shirt-trainer',
        color: '#333333',
        text: 'T',
        left: 120.5,
        top: 311,
      },
    ],
  },
  '1442_1442': {
    field: 'field-01',
    voetbalvorm: '11',
    pitchType: 'default',
    background: '#69C292',
    iconType: 'defaultIcon',
    objects: [
      {
        variation: 'goal-01',
        color: null,
        text: null,
        left: 311,
        top: 52,
      },
      {
        variation: 'goal-01',
        color: null,
        text: null,
        left: 310,
        top: 551,
      },
      {
        variation: 'field-text',
        color: null,
        text: '',
        left: 595,
        top: 307.5,
        angle: 90,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '5',
        left: 437,
        top: 199,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '1',
        left: 310,
        top: 111,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '2',
        left: 178,
        top: 200,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '4',
        left: 265,
        top: 201,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '3',
        left: 353,
        top: 200,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '3',
        left: 351,
        top: 406,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '1',
        left: 309,
        top: 500,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '2',
        left: 437,
        top: 406,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '4',
        left: 265,
        top: 405,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '10',
        left: 266,
        top: 250,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '5',
        left: 177.4,
        top: 405.8,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '8',
        left: 264.4,
        top: 326.8,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '6',
        left: 353.4,
        top: 324.8,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '9',
        left: 352.4,
        top: 252.8,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '11',
        left: 177.4,
        top: 325.8,
      },
      {
        variation: 'shirt-attack',
        color: '#FFF865',
        text: '7',
        left: 436.4,
        top: 326.8,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '9',
        left: 267.4,
        top: 358.8,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '10',
        left: 354.4,
        top: 358.8,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '7',
        left: 180.4,
        top: 287.8,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '11',
        left: 440.4,
        top: 289.8,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '6',
        left: 265.4,
        top: 292.8,
      },
      {
        variation: 'shirt-defend',
        color: '#E14F4F',
        text: '8',
        left: 352.4,
        top: 292.8,
      },
      {
        variation: 'ball',
        color: null,
        text: null,
        left: 307.4,
        top: 480.8,
      },
      {
        variation: 'shirt-trainer',
        color: '#333333',
        text: 'T',
        left: 120.5,
        top: 311,
      },
    ],
  },
};
